import { getFeatureToggleList } from '../Reducers/FeatureToggleReducer.ts';
import store from '../store';

export const isCalendarHomePage = () => {
  const state = store.getState();
  const featureToggleList = getFeatureToggleList(state);
  const isCalendarEnabled = featureToggleList?.Calendar?.IsEnabled;
  if (!isCalendarEnabled) {
    return false;
  }
  const isCandidateCRMDisabled = !featureToggleList?.CandidateCRM?.IsEnabled;
  const isJobListDisabled = !featureToggleList?.JobList?.IsEnabled;
  const isConnectDisabled = !featureToggleList?.Connect?.IsEnabled;

  return isCandidateCRMDisabled && isJobListDisabled && isConnectDisabled;
};
